import { TaskItemSkeletonComponent } from './task-item-skeleton.component';

export default angular
  .module('sfMobile.components.task-item-skeleton', [
    'sfMobile.components.text-skeleton',
  ])
  .component('sfTaskItemSkeleton', TaskItemSkeletonComponent).name;
